import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx } from "vue";
import { computed } from "vue";
import CloudTest from "@/components/CloudTest/index.vue";
import { useRoute } from "vue-router";
import { useCounterStore } from "@/store/user";
import { permissionStore } from "@/store/permission";
import { appCounterStore } from "@/store/app";
export default /*#__PURE__*/ _defineComponent({
    name: 'AppMain',
    setup(__props) {
        const permission_store = permissionStore();
        const userStore = useCounterStore();
        const userType = userStore.getUserInfo.type;
        const appStore = appCounterStore();
        const sidebar = computed(() => appStore.sidebar);
        const route = useRoute();
        const whitelist = ["dashboardIndex", "logIndex", "personal"];
        const hasPermission = computed(() => {
            if (userType !== "sub") {
                return true;
            }
            if (whitelist.includes(route.name)) {
                return true;
            }
            if (permission_store.getSubPermissions.length) {
                return true;
            }
            return false;
        });
        const mainStyle = computed(() => {
            if (route.meta.maxWidth) {
                return {
                    "max-width": route.meta.maxWidth,
                    margin: "0 auto"
                };
            }
            return {};
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createBlock(_Transition, {
                name: "fade-transform",
                mode: "out-in"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("section", {
                        class: _normalizeClass(["app-main", { expand: _unref(sidebar) }]),
                        style: _normalizeStyle(_unref(mainStyle))
                    }, [
                        (_unref(hasPermission))
                            ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
                            : (_openBlock(), _createBlock(CloudTest, {
                                key: 1,
                                class: "no_permission",
                                text: "暂无权限"
                            }))
                    ], 6)
                ]),
                _: 1
            }));
        };
    }
});
